// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_T3","refLinkDesktop":"e_U3","titleFont":"e_V3"};